/**
 * Segment name utilities
 */

export interface Segment {
  id: string
  name: string
}

export interface SegmentGroup {
  id: string
  segments: Segment[]
}

export interface Question {
  segmentGroupId?: string | null
  otherOptions?: {
    otherLabel?: string
  } | null
}

/**
 * Get the display name for a segment, handling INT_OTHER translation
 *
 * @param segment - The segment object
 * @param options - Optional context for resolving INT_OTHER labels
 * @returns The segment display name
 */
export function segmentName(
  segment: Segment | null | undefined,
  options?: {
    segmentGroups?: SegmentGroup[]
    questions?: Question[]
  }
): string | null {
  if (!segment) {
    return null
  }

  // Handle INT_OTHER segments
  if (segment.name === 'INT_OTHER') {
    if (options?.segmentGroups && options?.questions) {
      // Find the segment group this segment belongs to
      const segmentGroup = options.segmentGroups.find((sg) => sg.segments.some((s) => s.id === segment.id))

      if (segmentGroup) {
        // Find the question for this segment group
        const question = options.questions.find((q) => q.segmentGroupId === segmentGroup.id)

        if (question?.otherOptions?.otherLabel) {
          return question.otherOptions.otherLabel
        }
      }
    }

    // Default fallback for INT_OTHER
    return 'Other'
  }

  return segment.name
}
